export default {
  dataInicial: {
    value: '',
    required: false,
    state: null
  },
  mensagemForaHorario: {
    value: '',
    required: false,
    state: null
  },
  mensagemBoasVindas: {
    value: '',
    required: false,
    state: null
  },
  mensagemAssumir: {
    value: '',
    required: false,
    state: null
  },
  mensagemTransferir: {
    value: '',
    required: false,
    state: null
  },
  mensagemFinalizar: {
    value: '',
    required: false,
    state: null
  },
  mensagemNps: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/mensagensautomaticas/components/add/mensagensautomaticasadd-form.js